{
  "navigation.group.myViews": "My views",
  "navigation.group.analytics": "Operations & analytics",
  "navigation.group.system": "System",
  "navigation.item.overview": "Overview",
  "navigation.item.customers": "Customers",
  "navigation.item.reports": "Reports",
  "navigation.item.notifications": "Notification center",
  "navigation.item.systemConfiguration": "System configuration",
  "navigation.item.projects": "Projects",
  "navigation.item.categories": "Ticket categories",
  "navigation.item.routingRules": "Routing rules",
  "navigation.item.organization": "Teams & agents",
  "navigation.item.ai": "AI",
  "navigation.item.systemSettings": "System settings",
  "ticketView.all.label": "All tickets",
  "ticketView.all.title": "All tickets",
  "ticketView.all.description": "View, filter, and manage all customer tickets.",
  "ticketView.assigned.label": "Assigned to me",
  "ticketView.assigned.title": "Assigned to me",
  "ticketView.assigned.description": "View tickets currently assigned to you.",
  "ticketView.unassigned.label": "Unassigned",
  "ticketView.unassigned.title": "Unassigned tickets",
  "ticketView.unassigned.description": "View tickets routed to a support team without an assignee; claim or manually assign them.",
  "ticketView.participating.label": "Participating",
  "ticketView.participating.title": "Participating tickets",
  "ticketView.participating.description": "View tickets where you are participating as a collaborator.",
  "ticketView.uncategorized.label": "Needs category",
  "ticketView.uncategorized.title": "Needs category",
  "ticketView.uncategorized.description": "Work through tickets that still have no category. Closed and cancelled tickets can no longer be changed, so they stay out of the queue.",
  "ticketView.recentlyResolved.label": "Recently resolved",
  "ticketView.recentlyResolved.title": "Recently resolved",
  "ticketView.recentlyResolved.description": "View recently completed tickets ordered by resolution time.",
  "shell.workspaceNavigation": "Workspace navigation",
  "shell.systemNavigation": "System configuration navigation",
  "shell.expandSidebar": "Expand sidebar",
  "shell.collapseSidebar": "Collapse sidebar",
  "shell.closeSidebar": "Close sidebar",
  "shell.openNavigation": "Open navigation",
  "shell.searchAndCommands": "Search and commands",
  "shell.openSearchAndCommands": "Open search and commands",
  "shell.commandPalette.title": "Search and commands",
  "shell.commandPalette.description": "Open a page or enter a term to start searching.",
  "shell.commandPalette.placeholder": "Search or enter a command…",
  "shell.commandPalette.empty": "No pages or search scopes are available.",
  "shell.commandPalette.current": "Current",
  "shell.commandPalette.searchFor": "Search for “{query}” in",
  "shell.commandPalette.scope.all": "Entire workspace",
  "shell.commandPalette.scope.tickets": "Tickets",
  "shell.commandPalette.scope.customers": "Customers",
  "shell.commandPalette.scope.agents": "Members",
  "search.title": "Search",
  "search.description": "Find tickets, customers, and members across the workspace.",
  "search.descriptionWithQuery": "Search term: “{query}”",
  "search.scope.all": "All",
  "search.scope.tickets": "Tickets",
  "search.scope.customers": "Customers",
  "search.scope.agents": "Members",
  "search.results.title": "Search results",
  "search.results.description": "Results in “{scope}” will appear here.",
  "search.noQuery.title": "Enter something to search",
  "search.noQuery.description": "Use the search entry in the top bar to begin.",
  "shell.dismissTask": "Dismiss task status",
  "shell.dismissOperation": "Dismiss operation result",
  "shell.taskRunning": "Task in progress",
  "shell.taskProgress": "Task progress: {progress}%",
  "shell.mainNavigation": "Main navigation",
  "shell.returnWorkspace": "Back to workspace",
  "shell.systemConfiguration": "System configuration"
}
